export default {
  BASE: 'BASE',
  UPGRADE: 'UPGRADE',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  SUPERAPPLY: 'SUPERAPPLY',
};
